import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const defaultContainerSx = {
	display: 'block',
	backgroundColor: '#fff',
	height: 'auto',
	borderRadius: '10px',
	margin: '30px auto',
	width: '100%',
	maxWidth: '920px',
	minWidth: '550px',
	padding: '25px',
	textAlign: 'left',
	// Global .app-content sets overflow:hidden; that clips MUI Grid negative margins and breaks form layouts.
	overflow: 'visible',
};

const defaultTitleSx = {
	display: 'block',
	fontSize: '1.125rem',
	fontWeight: 500,
	color: '#003c8a',
	fontFamily: '"Lato", "Source Sans Pro", sans-serif',
	textAlign: 'left',
};

export const defaultInnerPanelSx = {
	width: '100%',
	backgroundColor: '#eef4ff',
	border: '1px solid #dbe7fb',
	borderRadius: '8px',
	padding: 1.5,
};

export const ManagementPageCard = ({
	title = '',
	subtitle = '',
	header = null,
	children = null,
	className = '',
	sx = {},
	titleSx = {},
	subtitleSx = {},
	headerSx = {},
}) => {
	return (
		<Box className={className} sx={{ ...defaultContainerSx, ...sx }}>
			{header ? (
				<Box sx={{ mb: 3, ...headerSx }}>
					{header}
				</Box>
			) : null}

			{title ? (
				<Box sx={{ mb: 3, width: '100%', textAlign: 'left' }}>
					<Typography component="span" sx={{ ...defaultTitleSx, ...titleSx }}>
						{title}
					</Typography>
					{subtitle ? (
						<Typography variant="body2" color="text.secondary" sx={subtitleSx}>
							{subtitle}
						</Typography>
					) : null}
				</Box>
			) : null}

			{children}
		</Box>
	);
};

ManagementPageCard.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	header: PropTypes.node,
	children: PropTypes.node,
	className: PropTypes.string,
	sx: PropTypes.object,
	titleSx: PropTypes.object,
	subtitleSx: PropTypes.object,
	headerSx: PropTypes.object,
};

export default ManagementPageCard;
